module.exports = __webpack_public_path__ + "static/media/NL.f7ba6ffa.svg";